module.exports = __webpack_public_path__ + "media/step4_animation.ea734983.webm";